<template>
  <div class="flex flex-col items-center gap-4 text-12 bg-white p-8 rounded-sm" v-if="hasSlug">
    <WFTranslate k="offer-qr"></WFTranslate>
    <img :src="qr" class="w-80"/>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
    props: {
        poi: {
            default: null,
            type: Object
        }
    },
    computed: {
        hasSlug() {
            if (this.poi && this.poi.getAttributeString("slug")) {
                return true;
            }

            return false;
        }
    },
    data() {
        return {
            qr: null,
        };
    },
    watch: {
        poi() {
            this.genQR(this.poi);
        },
    },
    mounted() {
        this.genQR(this.poi);
    },
    methods: {
        genQR (_poi) {
            if(_poi) {
                let slug = this.$wayfinder.settings.get("template.project.slug", "lounakeskus")
                let url = "https://astri.ee/" + slug + "/" + _poi.getAttributeString("slug");
                QRCode.toDataURL(url).then((val) => {
                    this.qr = val;
                })
            }
        }
    },
};
</script>